<mat-toolbar color="primary" class="mat-elevation-z4">
    <span>Replace Instrument</span>
</mat-toolbar>
<div class="replace-instrument-container">
    <div>
        Current Instrument Serial Number: <strong>{{currentInstrumentSerialNumber}}</strong>
    </div>
    <div class="instruments-container">
        <div class="instrument-groups-container">
            <b>CC Instrument Groups:</b>
            <app-group-select [groups]="instrumentGroups"
                [groupIdProp]="'instrumentGroupId'" [groupDisplayProp]="'name'" [groupItemsProp]="'instruments'"
                [itemIdProp]="'instrumentId'" [itemDisplayProp]="'instrumentSerial'"
                (groupSelected)="onSelectGroup($event)" (itemSelected)="onSelectItem($event)"
                [selectedItems]="selectedInstruments" [hideGroupSelection]="true">
            </app-group-select>
            <b>Type an Instrument Serial Number:</b>
            <input type="text" [(ngModel)]="customSerialNumber" />
            <div class="button-container">
                <button mat-raised-button class="success-button" (click)="onAddInstrument()">
                    <mat-icon>add</mat-icon>
                    Add
                </button>
            </div>
        </div>
        <div class="instrument-selected-container">
            <b>Instruments selected:</b>
            <div class="selected-instruments-list">
                <div *ngFor="let instrument of selectedInstruments" class="instrument-row">
                    <div class="instrument-serial-number">{{ instrument.instrumentSerial }}</div>
                    <div class="instrument-cell">
                        <button class="error" mat-icon-button (click)="removeInstrument(instrument)">
                            <mat-icon>remove_circle</mat-icon>
                        </button>
                    </div>
                    <mat-icon *ngIf="instrument.hasLUTFile" class="success">
                        check_circle
                    </mat-icon>
                    <mat-icon *ngIf="!instrument.hasLUTFile" class="error">
                        cancel
                    </mat-icon>
                    <div class="instrument-cell" *ngIf="!instrument.hasLUTFile">
                        <button class="sync-device-btn" mat-raised-button color="primary"
                            (click)="syncDevice(instrument)">
                            Upload LUT
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="actions">
    <button mat-raised-button (click)="cancel()">Cancel</button>
    <div class="separator"></div>
    <button mat-raised-button (click)="continue()" color="primary" [disabled]="isDisabled()">Continue</button>
</div>